<template>
    <div class="default-layout">
        <van-collapse v-model="activeNames">

            <van-collapse-item name="basicInformation" title="基本信息">
                <basic-information ref="basicInformation"></basic-information>
            </van-collapse-item>

            <van-collapse-item name="exportInvoice" title="出口发票">
                <van-row class="non-bottom"></van-row>
                <van-row class="add-btn" type="flex" justify="center" @click="addExportInvoice">
                    <i></i>
                    <span>添加发票</span>
                </van-row>
                <van-row class="non-bottom"></van-row>
                <export-invoice-card ref="exportInvoiceCard"></export-invoice-card>
                <export-invoice v-if="exportInvoiceVisible" @close="exportInvoiceVisible = false"
                                ref="exportInvoice"></export-invoice>
            </van-collapse-item>

            <van-collapse-item name="exportProduct" title="出口商品">
                <van-row class="non-bottom"></van-row>
                <van-row class="add-btn" type="flex" justify="center" @click="addExportProduct">
                    <i></i>
                    <span>添加商品</span>
                </van-row>
                <van-row class="non-bottom"></van-row>
                <export-product-card ref="exportProductCard"></export-product-card>
                <export-product v-if="exportProductVisible" :transportList="transportList"
                                :exportInvoiceList="exportInvoiceList"
                                @close="exportProductVisible = false" ref="exportProduct"></export-product>
            </van-collapse-item>

            <van-collapse-item name="pictureMark" title="附件-图片唛头">
                <van-row class="non-bottom"></van-row>
                <van-row class="add-btn" type="flex" justify="center" @click="addPictureMark">
                    <i></i>
                    <span>添加图片唛头</span>
                </van-row>
                <van-row class="non-bottom"></van-row>
                <picture-mark-card ref="pictureMarkCard"></picture-mark-card>
                <picture-mark v-if="pictureMarkVisible" @close="pictureMarkVisible = false"
                              ref="pictureMark"></picture-mark>
            </van-collapse-item>

            <van-collapse-item name="evidenceData" title="附件-佐证资料（运输单据和商业发票）">
                <van-row class="non-bottom"></van-row>
                <van-row class="add-btn" type="flex" justify="center" @click="addEvidenceData">
                    <i></i>
                    <span>添加佐证资料</span>
                </van-row>
                <van-row class="non-bottom"></van-row>
                <evidence-data-card ref="evidenceDataCard"></evidence-data-card>
                <evidence-data v-if="evidenceDataVisible" @close="evidenceDataVisible = false"
                               ref="evidenceData"></evidence-data>
            </van-collapse-item>

            <van-collapse-item name="additionalInformation" title="补充信息">
                <additional-information ref="additionalInformation" :enterpriseRecordInfo="enterpriseRecordInfo"></additional-information>
            </van-collapse-item>
        </van-collapse>

        <van-row class="default-layout-footer" style="padding: .1rem 4% 0;margin: .1rem auto 0">
            <van-button class="back" @click="handleConfirm(false)" style="width: 100%">保存</van-button>
        </van-row>

        <van-row class="default-layout-footer" type="flex" justify="space-between">
            <van-button class="previous" @click="handleConfirm(true)">发送到贸促会</van-button>
            <van-button class="previous" style="opacity:0.5" @click="goSingleWindow">发送到海关单一窗口</van-button>
        </van-row>

    </div>
</template>

<script>
    import {eventBus, noticeManager} from "@zhoujianhui/vip-core"
    import BasicInformation from './basic/BasicInformation'
    import ExportInvoice from './invoice/ExportInvoice'
    import ExportInvoiceCard from './invoice/ExportInvoiceCard'
    import ExportProduct from './product/ExportProduct'
    import ExportProductCard from './product/ExportProductCard'
    import PictureMark from './picturemark/PictureMark'
    import PictureMarkCard from './picturemark/PictureMarkCard'
    import EvidenceData from './evidencedata/EvidenceData'
    import EvidenceDataCard from './evidencedata/EvidenceDataCard'
    import AdditionalInformation from './additional/AdditionalInformation'
    import OriginCertificateCreationDto from '../dto/OriginCertificateCreationDto'
    import certificateService from '../service/certificate-service'
    import enterpriseManager from "../../enterprise/enterprise-manager";
    import originCertificateRegion from "../service/origin-certificate-region";
    import {Toast} from "vant";

    export default {
        name: "ApplicationComponent",
        data() {
            return {
                activeNames: ['basicInformation'],
                exportInvoiceVisible: false,
                exportProductVisible: false,
                evidenceDataVisible: false,
                pictureMarkVisible: false,

                originCertificate: new OriginCertificateCreationDto(),
                transportList: null,
                exportInvoiceList: [],
                url: "http://www.singlewindow.cn",
                socialCreditCode: "",
                enterpriseRecordInfo: null
            }
        },
        components: {
            BasicInformation,
            ExportInvoice,
            ExportProduct,
            AdditionalInformation,
            EvidenceData,
            PictureMark,
            ExportInvoiceCard,
            ExportProductCard,
            PictureMarkCard,
            EvidenceDataCard,

        },
        computed: {},
        created() {
            this.getEnterpriseInfo();
            // if (process.env.NODE_ENV === 'production') {
            //     this.socialCreditCode = enterpriseManager.getCurrentUserEnterpriseInfo().socialCreditCode;
            // }
            this.bindAddExportInvoiceEventBus();
        },
        mounted() {
            this.$store.dispatch('app-theme/addCachedRoutes', this.$options.name);
        },
        methods: {
            getEnterpriseInfo() {
                if (process.env.NODE_ENV === 'production') {
                    //校验企业是否贸促会备案
                    this.enterpriseRecordInfo = enterpriseManager.getCurrentUserEnterpriseRecordInfo();
                }else{
                  //测试数据
                    this.enterpriseRecordInfo = {
                        "id": 2,
                        "ccpitCode": "3201A0",
                        "compCode": "320664912",
                        "compName": "江苏擎天助贸科技有限公司",
                        "compEngName": "Jiangsu Skytech Zumoo Co., Limited",
                        "socialCreditCode": "91320191MA1WY6WX3A",
                        "provinceCode": "32",
                        "customsCode": "3201360266",
                        "compStatus": "1",
                        "ecoAllowPrint": "0",
                        "isExist": "1",
                        "signers": [
                            {
                              "id": 8,
                              "signerName": "景亚琼",
                              "signerStatus": "1"
                            },
                            {
                              "id": 9,
                              "signerName": "刘晶",
                              "signerStatus": "1"
                            }
                        ]
                    }
                }
                this.socialCreditCode = this.enterpriseRecordInfo.socialCreditCode;
            },
            //校验企业是否在贸促会备案
            async checkEnterpriseIsPromoter() {
                const result = await enterpriseManager.searchCurrentUserEnterpriseRecordInfo(this.socialCreditCode);
                if (result.isSuccess()) {
                    if (!result.data) {
                        Toast.fail('该企业还未在贸促会备案');
                        return false;
                    } else {
                        this.originCertificate.ccpitCode = result.data.ccpitCode;
                        this.originCertificate.compCode = result.data.compCode;
                        return true;
                    }
                } else {
                    Toast.fail('查询当前登录用户的企业备案信息失败！');
                    return false;
                }
            },
            bindAddExportInvoiceEventBus() {
                eventBus.$on("addExportInvoice", (exportInvoice) => {
                    this.exportInvoiceList.push(exportInvoice);
                })
            },
            bindEditTransportLineEventBus() {
                eventBus.$on("editTransportLine", (transportLine) => {
                    this.transportList = transportLine;
                });
            },
            //出口发票
            addExportInvoice() {
                this.exportInvoiceVisible = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs['exportInvoice'].$children[0].$el.scrollIntoView({
                            behavior: "smooth"
                        });
                    }, 100)
                })
            },
            //出口商品
            addExportProduct() {
                this.exportProductVisible = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs['exportProduct'].$children[0].$el.scrollIntoView({
                            behavior: "smooth"
                        });
                    }, 100)
                })
            },
            //图文唛头
            addPictureMark() {
                this.pictureMarkVisible = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs['pictureMark'].$children[0].$el.scrollIntoView({
                            behavior: "smooth"
                        });
                    }, 100)
                })
            },
            //佐证材料
            addEvidenceData() {
                this.evidenceDataVisible = true;
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs['evidenceData'].$children[0].$el.scrollIntoView({
                            behavior: "smooth"
                        });
                    }, 100)
                })
            },


            async handleConfirm(isPromoter) {
                this.originCertificate.regionCode = originCertificateRegion.REGION_CODE_22.value;
                if (process.env.NODE_ENV === 'production') {
                    this.originCertificate.isPromoter = isPromoter;
                    if (!await this.checkEnterpriseIsPromoter()) {//验证是否在贸促会备案
                        return false;
                    }
                }
                // 步骤一 基础信息
                console.log("---------基础信息-------------------");
                let validateBasicResult = await this.formRefValidate("basicInformation");
                if (validateBasicResult) {
                    let basicInformation = this.$refs["basicInformation"].getBasicInformation();
                    Object.assign(this.originCertificate, basicInformation);
                } else {
                    this.activeNames = ["basicInformation"];
                    return false;
                }

                // 步骤二 出口发票
                console.log("---------出口发票信息-------------------");
                let validateExportInvoiceCardResult = await this.formRefValidate("exportInvoiceCard");
                if (validateExportInvoiceCardResult) {
                    this.originCertificate.originCertificateInvoices = this.$refs["exportInvoiceCard"].getExportInvoices();
                    if (this.$refs["exportInvoice"]) {
                        await this.formRefValidate("exportInvoice");
                    }
                } else {
                    this.activeNames = ["exportInvoice"];
                    return false;
                }

                // 步骤三 出口商品
                console.log("---------出口商品信息-------------------");
                let validateExportProductCardResult = await this.formRefValidate("exportProductCard");
                if (validateExportProductCardResult) {
                    this.originCertificate.originCertificateProducts = this.$refs["exportProductCard"].getExportProducts();
                    if (this.$refs["exportProduct"]) {
                        await this.formRefValidate("exportProduct");
                    }
                } else {
                    this.activeNames = ["exportProduct"];
                    return false;
                }

                // 步骤四 图片唛头
                console.log("---------图片唛头信息-------------------");
                // let validatePictureMarkCardResult = await this.formRefValidate("pictureMarkCard");
                // if (validatePictureMarkCardResult) {
                    this.originCertificate.originCertificateMarks = this.$refs["pictureMarkCard"].getPictureMarks();
                    if (this.$refs["pictureMark"]) {
                        await this.formRefValidate("pictureMark");
                    }
                // } else {
                //     this.activeNames = ["pictureMark"];
                //     return false;
                // }

                // 步骤五 佐证资料
                console.log("---------佐证资料信息-------------------");
                let validateEvidenceDataCardResult = await this.formRefValidate("evidenceDataCard");
                if (validateEvidenceDataCardResult) {
                    this.originCertificate.originCertificateEvidences = this.$refs["evidenceDataCard"].getEvidenceDatas();
                    if (this.$refs["evidenceData"]) {
                        await this.formRefValidate("evidenceData");
                    }
                } else {
                    this.activeNames = ["evidenceData"];
                    return false;
                }

                // 步骤六 补充信息
                console.log("---------补充信息-------------------");
                let validateAdditionalResult = await this.formRefValidate("additionalInformation");
                if (validateAdditionalResult) {
                    let additionalInformation = this.$refs["additionalInformation"].getAdditionalInformation();
                    Object.assign(this.originCertificate, additionalInformation);

                } else {
                    this.activeNames = ["additionalInformation"];
                    return false;
                }

                const result = await certificateService.addOriginCertificate(this.originCertificate);
                if (result.isSuccess()) {
                    await this.$store.dispatch('app-theme/deleteCachedRoutes', 'ApplicationComponent');
                    await this.$router.push('/origin-certificate/application-order');
                }
                noticeManager.showMessage(result.msg, result.type);
            },

            //通用表单验证校验
            formRefValidate(formName) {
                if (this.$refs[formName] === undefined) {
                    this.activeNames = [formName];
                    return this.$nextTick().then(() => {
                        if (this.$refs[formName]) {//发票卡片、商品卡片、图片唛头、佐证资料展开后,form表单尚未建立
                            return this.$refs[formName].validate();
                        } else {
                            return new Promise(resolve => resolve(false))
                        }
                    })
                } else {
                    return this.$refs[formName].validate()
                }
            },
            goSingleWindow() {
                window.EappApi.goThirdUrl(this.url);
            }

        }
    }
</script>

<style lang="scss" scoped>
    @import "src/app-theme/style/rcep-layout";
</style>